import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Chip,
  Stack,
  Typography,
} from '@mui/material'
import dayjs from 'dayjs'
import { useCurrentUser } from '~/common/use-current-user'
import { useAccountCropCount } from './use-account-crop-count'

const StatRow = ({ description, children }) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', md: '2fr 1fr' },
      columnGap: 2,
      rowGap: { xs: 0.5, md: 0 },
      alignItems: 'center',
    }}
  >
    <Typography variant="body2" color="text.secondary">{description}</Typography>
    <Box sx={{ display: 'flex', justifyContent: { xs: 'flex-start', md: 'flex-end' } }}>
      {children}
    </Box>
  </Box>
)

const PLAN_COLORS = { Pro: 'primary', Supporter: 'secondary' }

export const AccountOverviewCard = () => {
  const { currentUser } = useCurrentUser()
  const { cropCount } = useAccountCropCount()

  const memberSince = currentUser?.created_at ? dayjs(currentUser.created_at) : null
  const seasonsWeathered = memberSince ? Math.floor(dayjs().diff(memberSince, 'month') / 3) : null
  const planTier = currentUser?.plan_tier ?? 'Free'

  return (
    <Card variant="outlined">
      <CardHeader title="Overview" sx={{ pb: 0 }} />
      <CardContent>
        <Stack spacing={1.5}>
          <StatRow description="The date you joined TerraPlanner.">
            <Typography variant="body2">
              {memberSince ? memberSince.format('MMMM D, YYYY') : '—'}
            </Typography>
          </StatRow>

          <StatRow description="Full seasons you've been growing with TerraPlanner.">
            <Typography variant="body2">
              {seasonsWeathered !== null ? seasonsWeathered : '—'}
            </Typography>
          </StatRow>

          <StatRow description="Total crops and plantings recorded across all seasons.">
            <Typography variant="body2">
              {cropCount !== null ? cropCount.toLocaleString() : '…'}
            </Typography>
          </StatRow>

          <StatRow description="Your current membership tier.">
            <Chip
              label={planTier}
              color={PLAN_COLORS[planTier] ?? 'default'}
              size="small"
              variant={planTier === 'Free' ? 'outlined' : 'filled'}
            />
          </StatRow>
        </Stack>
      </CardContent>
    </Card>
  )
}
